import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { HttpClient} from '@angular/common/http';
import {environment as env} from '../../../environments/environment';
import {LanguageService} from '../../services/language.service';

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.css']
})
export class OrderDetailsComponent implements OnInit {
  orderId:any;
  ordDetail:[]=[];
  imgurl:string;
  ordTax:any;
  netPayable:any;
  payMentMethod:string;
  isLoading:boolean;
  showLang:string;
  payMentMethod_ar:string;
  ordStatus:string;
  ordStatus_ar:string;


  constructor(private route:ActivatedRoute,
    private router:Router,private http:HttpClient,
    private langObj:LanguageService) {
      this.imgurl =  env.imgurl;
      this.langObj.langStr.subscribe((data)=>{
        this.showLang = data;
      });
     }

  ngOnInit(): void {

    this.showLang = localStorage.getItem("showLang");
    if(this.showLang == null && this.showLang == undefined){
     this.showLang = 'en';
    }

    this.isLoading = true;
    this.route.params.subscribe((params:Params)=>{
      if(params['ordid']){
        this.orderId = params['ordid'];
      }else{
        // Redirect
      }
  })

  //get order details
  this.http.post(env.apiurl+'order-detail', {
    oid:this.orderId
  }).subscribe(rawData=>{
    this.isLoading = false;
    this.ordDetail = rawData['data']; 
    console.log(this.ordDetail);
    this.netPayable = this.ordDetail['netPaid'];
    this.ordTax = (this.netPayable * 5)/100;
    if(this.ordDetail['payment_type'] == 'COD'){ 
      this.payMentMethod = "Cash on Delivery";
      this.payMentMethod_ar = "الدفع عند التوصيل";
    }else{
      this.payMentMethod = this.ordDetail['payment_type'];
    }

    if(this.ordDetail['order_status'] == '5'){
      this.ordStatus = "Canceled";
      this.ordStatus_ar = "ألغيت";
    }else{
      this.ordStatus = this.ordDetail['order_status'];
      this.ordStatus_ar = this.ordDetail['order_status_ar'];
    }

  });

}
  

}
